import { Http } from '../../utils/types'
import { GetBlob, ObjectGeneric } from '../../utils/types/generals'
import { OptionGroupList, OptionGroupType, ResponseAllDropDownList, TableResponse } from './reponse'

export const OptionGroupService = (client: Http) => ({
  getOptionGroup: async (query?: string): Promise<TableResponse> => {
    return await client.get(`option-group/detailed${query ? '?' + query : ''}`)
  },
  getOptionGroupById: async (id: number): Promise<OptionGroupList> => await client.get(`option-group/${id}`),
  getOptionType: async (): Promise<OptionGroupType> => await client.get(`types-option-group`),
  getAllDropList: async (): Promise<ResponseAllDropDownList> => await client.get('drop-downs/all'),
  deleteOptionGroupById: async (id: number) => await client.delete(`option-group/${id}`),
  createOptionGroup: async (body: ObjectGeneric) => await client.post('option-group', body),
  updateOptionGroup: async (body: ObjectGeneric, id: number, force?:boolean) => await client.put(`option-group/${id}${force ? '?force=true':''}`, body),
  downloadFile: async (data: {
    type: string
    query?: string
  }): Promise<GetBlob> =>
    await client.getBlob?.(
      `option-group/generate-file${data.query ? '?' + data.query + '&type=' + data.type : '?type=' + data.type}`
    ),
})
